/**
 * Created by wenqiang.li on 2017/11/7.
 */

const account = '/account/users';
const balance = '/account/balance';
const mining = '/account/mining';

export default {
  etfPage: '/ett', // etf交易
  futureBillsRage: '/future/trade/bill', // 合约账单
  etfBillsRage: '/ett/bills', // 交易账单

  salePage: '/sale', // 販売所

  walletPage: `${balance}/transaction`, // 钱包账户
  fuAccountPage: `${balance}/transaction/fuAccount`, // 合约账户
  fiAccountPage: `${balance}/transaction/fiAccount`, // 法币账户
  etfAccountPage: `${balance}/transaction/etfAccount`, // 法币账户

  rechargePage: `${balance}/wallet/recharge`, // 充币页面
  koDepositPage: `${balance}/wallet/KoDeposit`, // 韩元充值
  usdDepositPage: `${balance}/wallet/cashDeposit`, // 美元充值
  usdDetailPage: `${balance}/wallet/cashDeposit/usdDepositDetail/`,
  koDepositDetailPage: `${balance}/wallet/KoDeposit/DepositDetail/`, // 韩元充值详情

  withdrawPage: `${balance}/wallet/withdrawCurrency`, // 提币页面
  koWithdrawPage: `${balance}/wallet/KoWithdraw`, // 提币页面
  usdWithdrawPage: `${balance}/wallet/cashWithdraw`, // 提币页面
  usdWDetailPage: `${balance}/wallet/cashWithdraw/usdWithdrawDetail/`, // 美元提现 详情
  koWithdrawDetailPage: `${balance}/wallet/KoWithdraw/WithdrawDetail/`, // 韩元提现 详情

  mycardPage: `${balance}/card`, // 我的点卡页面
  cardPage: `${balance}/card/withdrawCard`, // 点卡转让页面
  walletBillsPage: `${balance}/wallet/AccountRecords`, // 钱包账单
  bindCardPage: `${balance}/wallet/cashDeposit/bindCard`, // 绑卡 美元
  bindCardWPage: `${balance}/wallet/cashWithdraw/bindCard`, // 绑卡 美元
  koDepositCardPage: `${balance}/wallet/KoDeposit/BindCard`, // 充值绑卡
  koWithdrawCardPage: `${balance}/wallet/KoWithdraw/BindCard`, // 充值绑卡

  lockDetailPage: `${balance}/wallet/lockDetail`, // 锁定详情
  miningDetailPage: `${mining}`, // 挖矿明细
  earningsDoubledDetailPage: `${mining}/earningsDoubled`, // 收益倍增
  encourageGoldDetailPage: `${mining}/encourageGold`, // 鼓励金发放

  withdrawAddressPage: `${balance}/wallet/WithdrawCurrency/AddAddress`, // 提现添加地址
  cardAddressPage: `${balance}/card/withdrawCard/AddAddress`, // 点卡添加地址

  // 个人信息
  profile: account,
  // 个人信息
  login: '/account/login',
  // 忘记登录密码
  forgetLoginPassword: `${account}/forgetLoginPassword`,
  // 安全中心
  security: `${account}/security`,
  // 子账号
  // subAccount: `${account}/subAccount`,
  // api
  myApi: `${account}/myApi`,
  // v3api
  myApiV3: `${account}/myApiV3`,
  // kyc认证
  verificationPage: `${account}/verification`,
  // 忘记资金密码
  forgetPwdPage: `${account}/security/forgetTradePassword`,
  // 设置资金密码
  setTradePassword: `${account}/security/modifyTradePassword/10`,
  // 修改资金密码
  modifyTradePassword: `${account}/security/modifyTradePassword/20`,
  // 忘记资金密码
  forgetTradePassword: `${account}/security/forgetTradePassword`,
  // 修改登录密码
  modifyLoginPassword: `${account}/security/modifyLoginPassword`,
  // 设置谷歌
  setGoogle: `${account}/security/modifyGoogle/10`,
  // 修改谷歌
  modifyGoogle: `${account}/security/modifyGoogle/20`,
  // 设置手机
  setPhone: `${account}/security/modifyPhone/10`,
  // 修改手机
  modifyPhone: `${account}/security/modifyPhone/20`,
  // 设置邮箱
  setEmail: `${account}/security/modifyEmail/10`,
  // 修改邮箱
  modifyEmail: `${account}/security/modifyEmail/20`,
};
